/**
 * legacy.js - 遗留 API 集中管理
 *
 * 本文件中的所有 API 在后端 router.go 中不存在，调用将返回 404。
 * 这些是从原始 IM 项目遗留下来的接口，集中存放便于后续追踪清理。
 * 如需启用相关功能，请先联系后端添加对应路由。
 */
import http from './httpRequest.js'

// ==================== 用户相关 ====================

/** @deprecated 后端不存在此路由 */
export function findUserById(id) {
	return http({
		url: `/user/find/${id}`,
		method: 'get'
	})
}

/** @deprecated 后端不存在此路由 */
export function findUserByName(name) {
	return http({
		url: '/user/findByName',
		method: 'get',
		params: { name: name }
	})
}

/** @deprecated 后端不存在此路由 */
export function updateUser(data) {
	return http({
		url: '/user/update',
		method: 'put',
		data: data
	})
}

/** @deprecated 后端不存在此路由 */
export function getOnlineStatus(userIds) {
	return http({
		url: '/user/terminal/online?userIds=' + userIds.join(','),
		method: 'get'
	})
}

/** @deprecated 后端不存在此路由 */
export function register(data) {
	return http({
		url: '/register',
		method: 'post',
		data: data
	})
}

// ==================== 好友相关 ====================

/** @deprecated 后端不存在此路由 */
export function addFriend(friendId) {
	return http({
		url: '/friend/add',
		method: 'post',
		params: { friendId: friendId }
	})
}

/** @deprecated 后端不存在此路由 */
export function deleteFriend(id) {
	return http({
		url: `/friend/delete/${id}`,
		method: 'delete'
	})
}

// ==================== 群组相关 ====================

/** @deprecated 后端不存在此路由 */
export function createGroup(groupName) {
	return http({
		url: `/group/create?groupName=${groupName}`,
		method: 'post'
	})
}

/** @deprecated 后端不存在此路由 */
export function getGroupInfo(groupId) {
	return http({
		url: `/group/find/${groupId}`,
		method: 'get'
	})
}

/** @deprecated 后端不存在此路由 */
export function getGroupMembers(groupId) {
	return http({
		url: `/group/members/${groupId}`,
		method: 'get'
	})
}

/** @deprecated 后端不存在此路由 */
export function modifyGroup(data) {
	return http({
		url: '/group/modify',
		method: 'put',
		data: data
	})
}

/** @deprecated 后端不存在此路由 */
export function deleteGroup(groupId) {
	return http({
		url: `/group/delete/${groupId}`,
		method: 'delete'
	})
}

/** @deprecated 后端不存在此路由 */
export function quitGroup(groupId) {
	return http({
		url: `/group/quit/${groupId}`,
		method: 'delete'
	})
}

/** @deprecated 后端不存在此路由 */
export function removeGroupMembers(data) {
	return http({
		url: '/group/members/remove',
		method: 'delete',
		data: data
	})
}

/** @deprecated 后端不存在此路由 */
export function inviteGroupMembers(data) {
	return http({
		url: '/group/invite',
		method: 'post',
		data: data
	})
}

// ==================== 消息相关 ====================

/** @deprecated 后端不存在此路由 */
export function recallMessage(type, id) {
	return http({
		url: `/message/${type}/recall/${id}`,
		method: 'delete'
	})
}

// ==================== 系统相关 ====================

/** @deprecated 后端不存在此路由 */
export function getSystemConfig() {
	return http({
		url: '/system/config',
		method: 'get'
	})
}
